import React from 'react'

const banner = props=>{
    return(
        <React.Fragment>
            <section>
                <div className={`banner-image ${props.brand}`}>
                    <div className="mx-width">
                        <div className="banner-text">
                            {props.children}
                        </div>
                    </div>
                 </div>
            </section>
        </React.Fragment>
    )
}
export default banner;